import React from 'react';

import styles from './HeroView.module.scss';
import { HeroComponent } from '@modules/services/shared/HeroComponent';

export const HeroView = () => {
  return (
    <section className={styles.inner_hero}>
      <HeroComponent
        imageAlt="About us banner image"
        title="About Us"
        imageLink="/images/about-us/about-us.webp"
        styles={styles}
      />
    </section>
  );
};
